export enum PageEditorRoleKeysEnum {
  MyAnecdotesEditorRole = 'my_anecdotes_personal_tasks',
  PolicyManagerEditorRole = 'policy_manager_editor_role',
  RiskManagerEditorRole = 'risk_editor_role',
  UarEditorRole = 'uar_editor_role',
  PluginsEditorRole = 'plugin_editor_role',
  PlaybooksEditor = 'playbooks_editor_role',
  SettingsEditor = 'settings_editor_role',
  TrustCenterEditor = 'trust_center_editor_role',
  EvidenceLabEditorRole = 'ticket_evidence_editor_role',
  DashboardEditorRole = 'dashboard_editor_role',
}

export enum ByAssigneeRoleEnum {
  RiskByAssignee = 'risk_contributor_role'
}

export enum PageViewerRoleEnum {
  RiskManageViewerRole = 'risk_reader_role',
  TrustCenterAccessManager = 'trust_center_access_manager_role',
  ReportingViewerRole = 'reporting_viewer_role',
}

export const AllPagesAccessRole = 'all_pages_access_role';
export const AllFrameworksRole = 'all_frameworks_role';
export const LimitedFrameworksRole = 'limited_frameworks_role';
export const AllEvidenceDataRole = 'all_evidence_data_role';
export const ManualEvidenceEditorRole = 'manual_evidence_editor_role';
export const LinkEvidenceEditorRole = 'link_evidence_editor_role';

export const DefaultEvidenceRoles = [AllEvidenceDataRole, ManualEvidenceEditorRole, LinkEvidenceEditorRole];

export type PageRole = PageEditorRoleKeysEnum | PageViewerRoleEnum;
